import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const employeePositionLocaleModule: LocaleModule = {
  name: "employeePosition",
  messages: { en: en, it: it },
};
